/**
 * icons.tsx — Ícones do header no estilo Feather (mesmos paths do tema AdminUX),
 * como SVG inline (stroke fino). O template usa data-feather; reproduzimos os
 * mesmos desenhos para casar peso/proporção sem depender da lib feather.
 */
import React from 'react';

interface Props {
  size?: number;
  className?: string;
}

const base = (size: number, className?: string) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  width: size,
  height: size,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  className,
});

export const IconMenu: React.FC<Props> = ({ size = 24, className }) => (
  <svg {...base(size, className)}>
    <line x1="3" y1="12" x2="21" y2="12" />
    <line x1="3" y1="6" x2="21" y2="6" />
    <line x1="3" y1="18" x2="21" y2="18" />
  </svg>
);

export const IconBell: React.FC<Props> = ({ size = 22, className }) => (
  <svg {...base(size, className)}>
    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
    <path d="M13.73 21a2 2 0 0 1-3.46 0" />
  </svg>
);

export const IconSun: React.FC<Props> = ({ size = 22, className }) => (
  <svg {...base(size, className)}>
    <circle cx="12" cy="12" r="5" />
    <line x1="12" y1="1" x2="12" y2="3" />
    <line x1="12" y1="21" x2="12" y2="23" />
    <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
    <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
    <line x1="1" y1="12" x2="3" y2="12" />
    <line x1="21" y1="12" x2="23" y2="12" />
    <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
    <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
  </svg>
);

export const IconMoon: React.FC<Props> = ({ size = 22, className }) => (
  <svg {...base(size, className)}>
    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
  </svg>
);

export const IconQuestion: React.FC<Props> = ({ size = 22, className }) => (
  <svg {...base(size, className)}>
    <circle cx="12" cy="12" r="10" />
    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
    <line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
);

/**
 * Recarregar (feather `refresh-cw`).
 *
 * Existe porque até 26/08/2026 este era o ÚNICO botão do header desenhado com
 * glifo de fonte (`bi bi-arrow-clockwise`), que segue o `font-size` (~16px) e
 * não o `size` dos irmãos — daí ele parecer menor na barra. Não parecia: era.
 */
export const IconRefresh: React.FC<Props> = ({ size = 22, className }) => (
  <svg {...base(size, className)}>
    <polyline points="23 4 23 10 17 10" />
    <polyline points="1 20 1 14 7 14" />
    <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
  </svg>
);
